import { apiFactory } from "../api_factory";

export const savedFiltersApi = apiFactory({
  path: `/api/v4/saved-filters`
});
